export default [
    {
        path: 'anexos/:id',
        component: require('./Anexo').default,
        meta: { middleware: 'auth', controller: 'GerenciadorArquivoController' }
    },
];


